export const TOUR_SEEN_STORAGE_KEY = 'ss_review_tour_seen_v1';

export function isTourSeen(): boolean {
  try {
    return localStorage.getItem(TOUR_SEEN_STORAGE_KEY) === '1';
  } catch {
    try {
      return sessionStorage.getItem(TOUR_SEEN_STORAGE_KEY) === '1';
    } catch {
      return false;
    }
  }
}

export function markTourSeen(): void {
  try {
    localStorage.setItem(TOUR_SEEN_STORAGE_KEY, '1');
  } catch {
    try {
      sessionStorage.setItem(TOUR_SEEN_STORAGE_KEY, '1');
    } catch {
      // The tour should still close for this session when storage is unavailable.
    }
  }
}

export function reviewerHasPriorActivity(
  reviewerId: string,
  annotations: readonly { reviewer_id: string }[],
  comments: readonly { reviewer_id: string }[],
  finishedAt: number | null,
): boolean {
  return finishedAt !== null
    || annotations.some((annotation) => annotation.reviewer_id === reviewerId)
    || comments.some((comment) => comment.reviewer_id === reviewerId);
}

export function shouldGateOnboardingTour(input: { seen: boolean; priorActivity: boolean }): boolean {
  return !input.seen && !input.priorActivity;
}

export interface OnboardingTourViewInput {
  seen: boolean;
  priorActivity: boolean;
  isOwner: boolean;
  tourOpen: boolean;
  reentryOpen: boolean;
  allowTourSkip: boolean;
}

export interface OnboardingTourView {
  mode: 'gated' | 'reentry' | null;
  allowSkip: boolean;
  writesSeenOnComplete: boolean;
}

export function onboardingTourView(input: OnboardingTourViewInput): OnboardingTourView {
  const gated = input.tourOpen
    && !input.isOwner
    && shouldGateOnboardingTour({ seen: input.seen, priorActivity: input.priorActivity });
  const mode = gated ? 'gated' : input.reentryOpen ? 'reentry' : null;

  return {
    mode,
    allowSkip: mode === 'gated' && input.allowTourSkip,
    writesSeenOnComplete: mode !== null,
  };
}
